import $ from 'jquery';

$('#show-faqs').on('click', function () {
    const $thisEl = $(this);

    $thisEl.parent().children('ul').slideDown(300);
    $thisEl.slideUp(300);
});
